<template>
  <el-row class="searcher" ref="searcher_box">
    <div class="searcher-container">
      <h1>{{ $t('MainPage.MainMenu.find_businesses_title') }}</h1>
      <h3>{{ $t('MainPage.MainMenu.find_businesses_description') }}</h3>

      <el-autocomplete :fetch-suggestions="querySearch" :placeholder="$t('MainPage.MainMenu.input_search_placeholder')" v-model="main_search" popper-class="main-searcher" @select="handleSelect" value-key="title">
        <template slot-scope="{ item }">
          <el-row>
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
                <img :src="item.logo_img_path"/>
            </el-col> -->
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">{{ item.title }}</el-col>
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">{{ item.short_description }}</el-col> -->
          </el-row>
        </template>
      </el-autocomplete>
    </div>
  </el-row>
</template>
<script>
import { particle } from '../../../assets/js/network-particles'

export default {
  name: 'SearcherBlock',
  data() {
    return {
      cities: [],
      main_search: '',
      center: {lat:-33.457967, lng:-70.653126},
      markers: [],
      zoom: 12,
      style: require("@/assets/styles/default.json"),
      city_select: '',
      results: [],
      merchants: [],
    };
  },
  methods: {
    querySearch(queryString,cb) {
      var cities = this.cities;
      cb(cities.filter(this.createFilter(queryString)));
    },
    createFilter(queryString) {
      return (city) => {
        if(queryString){
          return (city.country.toLowerCase() === this.$store.getters['lang/getLongLang'] && (city.title.toLowerCase().indexOf(queryString.toLowerCase()) === 0)) ? city: false;
        }
        else{
          return (city.country.toLowerCase() === this.$store.getters['lang/getLongLang']) ? city: false;
        }
      };
    },
    loadCities() {
      let self = this;
      self.$store.dispatch("listCities")
      .then(response => {
        self.cities = response.data;
      }).catch(error => {
        this.$message({
          type: 'info',
          message: 'Problema conectando a la API, favor reintente mas tarde.'
        });
        console.log(error);
      });
    },
    setCity( city, country ) {
      let self = this;
      let place_id = null;

      this.$geocoder.setDefaultMode('address');
      this.$geocoder.send({ city: city, country: country }, response => {
        let country_component = _.head(_.head(response.results).address_components.filter((component) => { if(_.includes(component.types, 'country')) return component}));

        self.$store.dispatch('app/setCurrentPlaceID', response.results[0].place_id);

        self.$store.dispatch("app/setCenterMap", response.results[0].geometry.location )
        .catch(error => {
          console.log(error);
        });

        let friendly_url = self.getFriendlyUrl(country_component.long_name) + '/' +self.getFriendlyUrl(city);

        //update City path
        // if(_.isEmpty(this.$store.getters['app/currentCity'].url_path)){
        //   self.$store.dispatch("updateCity",{ params: { id: this.$store.getters['app/currentCity'].id }, data: {
        //     url_path: friendly_url
        //   }}).then(response => {
        //     // console.log(response.data)
        //     console.log('path updated')
        //   }).catch(error => {
        //     console.log(error);
        //   });
        // }

        console.log(friendly_url)

        self.$router.push({ path: friendly_url });
      });

    },
    handleSelect(item) {
      let self = this;
      self.$store.dispatch("app/setCity", { city: item })
      .then(() => {
        self.setCity(item.title, item.country);

        // self.$router.push({ path: self+'/'+self.getFriendlyUrl(item.title) });
      })
      .catch(error => {
        console.log(error);
      });

    },
    getFriendlyUrl(value){
      function removeAccents(str) {
        let accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
        let accentsOut = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz-";
        str = str.split('');
        str.forEach((letter, index) => {
          let i = accents.indexOf(letter);
          if (i != -1) {
            str[index] = accentsOut[i];
          }
        })
        return str.join('');
      }

      if(this.$store){
        return removeAccents(value).toLowerCase().split(' ').join('-');
      }

    },
  },
  mounted(){


    // random background
    this.$refs.searcher_box.$el.classList.add('bg-'+_.random(1, 13));

    // particle animation
    (new particle()).init(this.$refs.searcher_box.$el);
  },
  created(){
    if (window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerendered) {
      return;
    }

    this.loadCities();

    // if (window.__PRERENDER_INJECTED &&
    //     window.__PRERENDER_INJECTED.prerendered) {
    //   return;
    // }
  }
};
</script>
<style>
/*sm and down*/
@media only screen and (max-width: 992px) {
  .searcher{
    h1{
      font-size: 2rem !important;
    }
    h3{
      font-size: 1.2rem !important;
    }
  }
  .main-searcher.el-autocomplete-suggestion li{
    font-size: 1.2rem !important;
  }
}
.searcher{
  overflow: hidden;
  .searcher-container{

    padding-top: 40vh;
  }

  canvas{
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }

  height: 100vh;
  background-color: #171717;
  /* padding-top: 40vh; */
  color: white;
  z-index: 1;

  &::before {
    z-index: -1;
    height: 100%;
    width: 100%;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* // background-image: url(http://web.frfr.me/dev/world-map-optimized.jpg); */
    /* background-image: url(https://images.unsplash.com/photo-1450849608880-6f787542c88a?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&s=786a67dca1d8791d181bfd90b16240d9); */
    background-position: center center;
    background-size: cover;
    opacity: 0.5;
  }

  &.bg-1::before{
    background-image: url(../../../assets/img/bg/1.jpg);
  }
  &.bg-2::before{
    background-image: url(../../../assets/img/bg/2.jpg);
  }
  &.bg-3::before{
    background-image: url(../../../assets/img/bg/3.jpg);
  }
  &.bg-4::before{
    background-image: url(../../../assets/img/bg/4.jpg);
  }
  &.bg-5::before{
    background-image: url(../../../assets/img/bg/5.jpg);
  }
  &.bg-6::before{
    background-image: url(../../../assets/img/bg/6.jpg);
  }
  &.bg-7::before{
    background-image: url(../../../assets/img/bg/7.jpg);
  }
  &.bg-8::before{
    background-image: url(../../../assets/img/bg/8.jpg);
  }
  &.bg-9::before{
    background-image: url(../../../assets/img/bg/9.jpg);
  }
  &.bg-10::before{
    background-image: url(../../../assets/img/bg/10.jpg);
  }
  &.bg-11::before{
    background-image: url(../../../assets/img/bg/11.jpg);
  }
  &.bg-12::before{
    background-image: url(../../../assets/img/bg/12.jpg);
  }
  &.bg-13::before{
    background-image: url(../../../assets/img/bg/13.jpg);
  }

  h1{
    font-size: 2vw;
    margin: 0 0 1vh 0;
  }

  h3{
    font-size: 1.2vw;
    margin: 0 0 4vh 0;
  }

  input::placeholder{
    color: grey;
  }

  /*  search input */
  input.el-input__inner{
    min-width: 50vw;
    color: grey;
    border-radius: 2rem;
  }

  .glow {
    z-index: -1;
    position: fixed;
    top: 50%;
    left: 50%;
    background-image: radial-gradient(circle closest-side, rgba(255, 255, 255, 0.025), transparent);
  }

  $duration: 25s;
  .glow-1 {
    width: 150vw;
    height: 150vh;
    margin-top: -75vh;
    margin-left: -75vw;
    animation: glow-1-move $duration linear infinite both;
  }
  @keyframes glow-1-move {
    from {
      transform: translate(-100%, 100%);
    }
    to {
      transform: translate(100%, -100%);
    }
  }
  .glow-2 {
    width: 100vw;
    height: 100vh;
    margin-top: -50vh;
    margin-left: -50vw;
    animation: glow-2-move $duration linear $duration / 3 infinite both;
  }
  @keyframes glow-2-move {
    from {
      transform: translate(-100%, 0%);
    }
    to {
      transform: translate(100%, 100%);
    }
  }
  .glow-3 {
    width: 120vw;
    height: 120vh;
    margin-top: -60vh;
    margin-left: -60vw;
    animation: glow-3-move $duration linear $duration / 3 * 2 infinite both;
  }
  @keyframes glow-3-move {
    from {
      transform: translate(100%, 100%);
    }
    to {
      transform: translate(0%, -100%);
    }
  }
}

.main-searcher.el-autocomplete-suggestion{
  font-family: 'Montserrat', sans-serif;
  text-align: left;
  /* width: 50vw; */
  .el-scrollbar{
    /* left: 0; */
    /* width: 50vw; */
  }
  li {
    padding: 0 5vw;
    margin: 0;
    line-height: 34px;
    cursor: pointer;
    color: black;
    font-size: 0.8vw;
    list-style: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-input__inner{
    color: black
  }
  img{
    max-height: 4vh;
  }
}

.pano {
  width: 500px;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/merchants/blocks/MainSearcherBlock.vue